import api from './api';
import analytics from './analytics';
import errorHandler from './errorHandler';

const services = [api, analytics, errorHandler];

const analyticsService = analytics.service;
const apiService = api.service;
const errorHandlerService = errorHandler.service;

export { apiService as api };
export { analyticsService as analytics };
export { errorHandlerService as errorHandler };

export default { start: () => services.map(service => service.start()) };
